
import { mapActions, mapGetters } from 'vuex';

import Navbar from '~/components/NavigationBar/Navbar.vue';
import Sidebar from './sidebar/';
import Widgets from './widgets/';
import NavbarMobile from './navbarMobile/';
import ShowCreatePostRounded from '~/components/ui/atom/buttons/ShowCreatePostRounded.vue';
import { ComponentIds } from '~/utils/componentIds';
import { appURLs } from '~/utils/route-redirects';
import { getBaseRouteName } from '~/utils/routeNames';
import { LeagueTabs } from '~/utils/constants/leagueConstants';

export default {
  name: 'Nav',
  components: {
    Navbar,
    Sidebar,
    Widgets,
    NavbarMobile,
    ShowCreatePostRounded,
  },
  props: {
    showWidgets: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      viewport: null,
    };
  },
  async fetch() {
    this.getMessageNotificationsAll({ userId: this.me.userId });
  },
  computed: {
    ...mapGetters('shared', ['showMobileBottomNavigation']),
    ...mapGetters('authentication', [
      'me',
      'profile',
      'isConnected',
      'profileId',
      'isEmailConfirmed',
    ]),
    ...mapGetters('profile', ['profile', 'profileLoading']),
    ...mapGetters('leagues', ['league']),
    widgetsContainerId() {
      return ComponentIds.WidgetsContainerId;
    },
    routeName() {
      return getBaseRouteName(this.$route);
    },
    isHomePage() {
      return this.routeName === appURLs.feed();
    },
    isLeaguePage() {
      return this.routeName === appURLs.leagueById().name;
    },
    isPrivateLeaguePage() {
      return this.isLeaguePage && this.league.data?.isOfficialLeague === false;
    },
    isDiscussionTab() {
      return this.$route.query.tab === LeagueTabs.DISCUSSION;
    },
    showCreatePostButton() {
      return (
        this.isHomePage || (this.isPrivateLeaguePage && this.isDiscussionTab)
      );
    },
  },
  methods: {
    ...mapActions('modals', ['showCreatePostModal']),
    ...mapActions('messaging', ['getMessageNotificationsAll']),
    openCreatePostModal() {
      if (this.isPrivateLeaguePage) {
        const league = this.league.data;
        if (!league) {
          throw new Error(
            'openCreatePostModal: called for a private league page but no league is loaded'
          );
        }
        this.showCreatePostModal({
          target: this.profileId,
          targetType: 'LEAGUE',
          league: {
            leagueId: league.leagueId,
            leagueName: league.name,
            topProfiles: league.topProfiles,
            playerCount: league.playerCount,
            leagueAvatarUri: league.leagueAvatarUri,
          },
        });
      } else {
        this.showCreatePostModal({
          target: this.profileId,
          targetType: 'PROFILE',
        });
      }
    },
  },
};
